var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"focus:outline-none inline-flex items-center justify-center rounded-md text-sm shadow-lg transition-all duration-150 ease-in-out",class:[
    _vm.rounded ? 'box_button_rounded inline rounded-full' : _vm.customSize,
    _vm.customClass ? _vm.customClass : _vm.theme,
    _vm.bold ? 'font-bold' : 'font-medium',
    { disabledStyle: _vm.disabled },
  ],attrs:{"type":"button","disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }